import Col from 'react-bootstrap/Col';
import SectionTitle from '../component/section-title/section-title';
import aboutImage1 from '../../src/assets/images/services/10.webp';
import aboutImage2 from '../../src/assets/images/services/11.webp';
import aboutImage3 from '../../src/assets/images/services/12.webp';
import Counter from '../component/counter/counter';
import Button from '../component/button/button';

function TeamSection() {
  return (
    <>
      <Col lg={6} className="mb-4 mb-lg-0">
        <SectionTitle
          extraClass=""
          title="Présentation du Conseil d'Administration."
          manyContent={[
            "Bienvenue sur la page dédiée au Conseil d'Administration de la Chambre de Commerce et d’Industrie Tuniso-Suisse.",
            "Notre chambre est dirigée par un Bureau Exécutif composé de dix membres élus par nos adhérents pour un mandat de trois ans. Chaque membre apporte une expertise précieuse issue de grandes entreprises suisses établies en Tunisie, renforçant ainsi notre capacité à soutenir et promouvoir les intérêts économiques bilatéraux entre nos deux pays.",
            
            "Nous sommes fiers de compter parmi nous des professionnels engagés et dévoués à la réussite de notre mission commune. Le Bureau Exécutif, agissant à titre bénévole, oriente et supervise les activités de la chambre afin de répondre aux besoins variés de nos membres et partenaires.",
            
            "Nous avons également l'honneur de compter parmi nous Son Excellence l’Ambassadeur de Suisse en Tunisie, M. Josef Renggli, qui occupe le poste de Président d'Honneur de notre chambre. Son engagement et son soutien renforcent notre lien privilégié avec la Suisse et enrichissent nos actions en faveur du développement économique et commercial."
          ]}
          
        />
        <Button btnClass="btn-light-round" btnText="En savoir plus" btnURL="/about-us" />
      </Col>

      <Col lg={6}>
        <div className="row">
          <div className="col-sm-6">
            <img
              className="img-fluid border-radius mb-4 mt-4"
              src={aboutImage1}
              alt=""
            />
            <img
              className="img-fluid border-radius mb-4 mb-sm-0"
              src={aboutImage2}
              alt=""
            />
          </div>
          <div className="col-sm-6">
            <img
              className="img-fluid border-radius mb-4"
              src={aboutImage3}
              alt=""
            />
            <Counter
              className="counter-primary-bg"
              themeColor="counter-light"
              countStart="1900"
              countEnd="2011"
              countTitle="Depuis l'année"
            />
          </div>
        </div>
      </Col>
    </>
  );
}

export default TeamSection;
